import { Model } from "../../model";
import { Culture } from "../../culture/culture";

export class ProductionPeriod implements Model {
	_id: string;
	initialDate: Date;
	endDate: Date;
	description: string;
	culture: Culture;
}